var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":`https://springmedia.go2cloud.org/aff_l?offer_id=3877&adv_sub=${_vm.uuid}&amount=${_vm.amount}`,"scrolling":"no","frameborder":"0","width":"1","height":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }